export type ThemeSetting = 'light' | 'dark' | 'system';

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function applyThemeForSetting(setting: ThemeSetting) {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  const resolved = setting === 'system' ? getSystemTheme() : setting;

  root.classList.toggle('dark', resolved === 'dark');
  root.classList.toggle('light', resolved === 'light');
  root.dataset.theme = resolved;
  root.dataset.themeSetting = setting;
}
